import { useCallback } from 'react'

import { DonationTableQueryParamsProps } from '../DonationListTable/DonationListTable.types'

import { LocaleKey } from '@percent/partner-dashboard/i18n/config'

type DonationCategoryOption = {
  label: string
  value: string
  text: LocaleKey
}

const donationCategoryOptions: DonationCategoryOption[] = [
  { label: 'Corporate Grants', value: 'grant', text: 'typography.donationCategory.grant' },
  { label: 'Employee Impact', value: 'employee_impact', text: 'typography.donationCategory.employeeImpact' },
  { label: 'Consumer Giving', value: 'consumer_giving', text: 'typography.donationCategory.consumerGiving' },
  { label: 'Corporate Donation', value: 'corporate_donation', text: 'typography.donationCategory.corporateDonation' },
  { label: 'Unclassified', value: 'unclassified', text: 'typography.donationCategory.unclassified' }
]

export const useDonationCategoryFilter = ({ queryParams, setQueryParams }: DonationTableQueryParamsProps) => {
  const onCategoryChange = useCallback(
    (category: string[]) => {
      setQueryParams({
        category
      })
    },
    [setQueryParams]
  )

  return {
    donationCategoryOptions,
    onCategoryChange,
    selectedCategories: queryParams?.category?.filter((kind): kind is string => kind !== null) || []
  }
}
